import React from "react";
import Page from "../components/Page";

// Import
import { useSelector } from "react-redux";

// Import for Display
import LoadingPage from "./LoadingPage";
import RichText from "../components/RichText";
import { useSubmitForm } from "../hooks/useSubmitForm";

function ContactPage() {
  const { handleSubmit } = useSubmitForm();

  // Accesing data.
  const singleTypeSlug = "contact-us";
  const { data } = useSelector((state) => state.cms);
  const cmsData = data[singleTypeSlug] && data[singleTypeSlug].attributes;

  // Only load if data has returned.
  if (!cmsData) return <LoadingPage />;

  return (
    <Page data-wf-page="6350019c50a14e171667adac" data-wf-site="634efd6b20b65bfc05be44e4">
      <div className="section wf-section">
        <div className="container w-container">
          <div className="divcontact">
            <div id="w-node-_9cbbabaf-c2db-2b8b-700f-d08fb8fb4cd9-1667adac" className="divcontacttext">
              <h1>{cmsData.title}</h1>
              <div>
                <RichText text={cmsData.richText} />
              </div>
              <div className="divcontactlist">
                {/* Render Repeatable Contact Info */}
                {cmsData.contactIcon &&
                  cmsData.contactIcon.map((item) => {
                    return (
                      <a href={item.slug} className="textlinkcontact">
                        <div className="divcontactinfo">
                          <img src={item.icon.data && item.icon.data.attributes.url} loading="lazy" alt="" className="contacticon" />
                          {item.information}
                        </div>
                      </a>
                    );
                  })}
              </div>
            </div>

            {/* Contact Form */}
            <div id="w-node-_9cbbabaf-c2db-2b8b-700f-d08fb8fb4cea-1667adac" className="formblockcontact w-form">
              <form onSubmit={handleSubmit} id="contact-form" name="email-form" data-name="Contact" method="get" className="formcontact">
                <div className="divtextfieldmultiple">
                  <div>
                    <label htmlFor="name-3">Name</label>
                    <input type="text" className="formtextfield w-input" maxLength={256} name="Name" data-name="name" placeholder="Your Name" id="name-3" required={true} />
                  </div>
                  <div id="w-node-bcbfb617-fe2e-b910-fee1-5fb015cd7def-1667adac">
                    <label htmlFor="cadetName">Cadet Name</label>
                    <input type="text" className="formtextfield w-input" maxLength={256} name="Cadet Name" data-name="cadetName" placeholder="Cadet Name" id="cadetName" />
                  </div>
                </div>
                <div className="divtextfieldmultiple">
                  <div id="w-node-_5f53c3e4-4a5d-66c5-fd9e-c7f36c914fd3-1667adac">
                    <label htmlFor="contact-email">Email</label>
                    <input type="email" className="formtextfield w-input" maxLength={256} name="Email" data-name="email" placeholder="Your Email" id="contact-email" required={true} />
                  </div>
                  <div id="w-node-_69b04d9a-3e64-5331-ead5-734065898a23-1667adac">
                    <label htmlFor="contact-phone">Telephone</label>
                    <input type="tel" className="formtextfield w-input" maxLength={256} name="Phone" data-name="phone" placeholder="Your Telephone " id="contact-phone" />
                  </div>
                </div>
                <div>
                  <label htmlFor="contact-subject">Subject </label>
                  <input type="text" className="formtextfield w-input" maxLength={256} name="Subject" data-name="subject" placeholder="General Inquiry " id="contact-subject" required={true} />
                </div>
                <div>
                  <label htmlFor="field">Your Message </label>
                  <textarea placeholder="Your Message" maxLength={5000} id="message" name="Message" data-name="message" className="formtextfield w-input" defaultValue={""} required={true} />
                </div>
                <div className="divalignmentright">
                  <input type="submit" data-wait="Please wait..." defaultValue="Submit" className="buttonsubmit w-button" />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
}

export default ContactPage;
